'use client'

import { useRemoteConfig } from '@moment/app-config-ui'

import { OPTIMIZATION_DEFAULT_PARAMETERS } from '@/app/feature-flags'

/**
 * Reads `use_evals_as_orders` from the `optimization_default_parameters`
 * remote config.
 */
export function useIsUsingEvalsAsOrders(): boolean {
  const { use_evals_as_orders } = useRemoteConfig(
    OPTIMIZATION_DEFAULT_PARAMETERS,
  )
  return use_evals_as_orders === true
}
